<template>
  <div>
    <div>进入中...</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    //2022.8.25 接收分站参数-----2024.12.10对原有的分站做优化
    //获取页面参数
    var url = window.location.href; //获取当前url

    //如果url地址中没有#走如下流程
    var index = url.indexOf("?id=");
    if (index > -1) {
      var id = url.substring(index + 4);
      id = id.trim();
      var lastChar = id.charAt(id.length - 1);
      if (lastChar == "#") {
        id = id.substring(0, id.length - 1);
      }
      //保存到store中
      this.$store.commit("set_fz_tag", id);
    }

    //获取到分站参数收， 进行页面跳转
    this.$router.push({ name: "main", params: { from: "index2" } });

  }
};
</script>
